

export class ThoughtOfTheDay implements IThoughtOfTheDay {
    thought!: string | undefined;
    thoughtBy!: string | undefined;

    constructor(data?: IThoughtOfTheDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thought = _data["thought"];
            this.thoughtBy = _data["thoughtBy"];
        }
    }

    static fromJS(data: any): ThoughtOfTheDay {
        data = typeof data === 'object' ? data : {};
        let result = new ThoughtOfTheDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thought"] = this.thought;
        data["thoughtBy"] = this.thoughtBy;
        return data; 
    }
}

export interface IThoughtOfTheDay {
    thought: string | undefined;
    thoughtBy: string | undefined;
}

